module.exports = __webpack_public_path__ + "img/background-wait.d8eebeb5.svg";